export default "__VITE_ASSET__$p1qna$j__"